import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React from 'react';
import { breakpoints, NAVBAR_HEIGHT_L, zIndexes } from '../../../utils/styleguide';
import ContentfulNavBar from '../../contentful-elements/navigationbar/ContentfulNavBar';
import PoweredByNavBar from '../navigation/NavBar/PoweredByNavBar';
import { NavBarServerProps } from '../../contentful-elements/util/navigation';

const Layout = styled.div<Props>`
  z-index: ${zIndexes.nav};
  position: absolute;
  top: 0;
  ${({ floating }) =>
    !floating &&
    css`
      position: relative;
    `}
  mix-blend-mode: normal;
  height: ${NAVBAR_HEIGHT_L}px;
  ${breakpoints.tablet} {
    height: ${NAVBAR_HEIGHT_L}px;
  }
`;

type Props = {
  floating?: boolean;
  initiallyTransparent?: boolean;
  navigationBar?: NavBarServerProps;
};

const Header = ({ floating, initiallyTransparent, navigationBar }: Props) => (
  <Layout floating={floating}>
    {navigationBar ? (
      <ContentfulNavBar navigationBar={navigationBar} initiallyTransparent={initiallyTransparent} />
    ) : (
      <PoweredByNavBar initiallyTransparent={initiallyTransparent} />
    )}
  </Layout>
);

export default React.memo(Header);
